import {Component, Input} from '@angular/core';
import {DynamicFormElementEl} from '../../interfaces/fields-components';
import {FormAllData, FormParts} from '../../interfaces/forms/form-element';

@Component({
  selector: 'app-error-box',
  standalone: false,
  templateUrl: './error-box.component.html',
  styleUrl: './error-box.component.scss',
})
export class ErrorBoxComponent {
  @Input() data!: DynamicFormElementEl & {
    formData: FormParts<FormAllData>;
  };

  // errorList$!: Observable<{field: string; errors: string[]}[]>;
  // hasErrors = false;

  // ngOnInit(): void {
  //   this.errorList$ = this.data.formGroup.valueChanges.pipe(
  //     map((_) => {
  //       return this.formService.getErrorList(this.data.formGroup);
  //     }),
  //   );
  // }

  // showErrors(bool: boolean, first?: boolean) {
  //   if (first) {
  //     this.hasErrors = bool;
  //   } else {
  //     this.hasErrors = this.hasErrors || bool;
  //   }
  // }
}
